var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 536,
    viewBox: "0 0 92 536",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93 0V536V501.417C93 477.239 93 465.15 90.3845 453.709C88.0651 443.563 84.2359 433.823 79.0249 424.814C73.1487 414.655 64.9158 405.802 48.45 388.097L44.55 383.903C28.0842 366.198 19.8513 357.345 13.9751 347.186C8.76408 338.177 4.93486 328.437 2.61546 318.291C0 306.85 0 294.761 0 270.583V264C0 241.222 0 229.833 2.32308 219.027C4.70093 207.966 8.86758 197.368 14.6588 187.649C20.3166 178.154 28.0727 169.814 43.5848 153.135L48.45 147.903C64.9158 130.198 73.1487 121.346 79.0249 111.186C84.2359 102.177 88.0651 92.4371 90.3845 82.2912C93 70.8503 93 58.7611 93 34.5827V0Z",
    fill: "url(#paint0_linear_64_2530)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_2530",
    x1: 93,
    y1: 264,
    x2: 0,
    y2: 264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0157FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CB3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.28b3dc9fb33e9e39bf4c687c996d97bd.svg";
export { ForwardRef as ReactComponent };